import { PaymentStatus } from '../enums/enums';
import { CustomerFilter } from '../interface/interface';
import { DEFAULT_FILTER } from './constants';

export const CUSTOMERS_FILTER: CustomerFilter = {
  ...DEFAULT_FILTER,
  startDate: '',
  endDate: '',
  paymentStatus: PaymentStatus.ALL,
};

export const PAYMENT_STATUS_OPTION = [
  {
    value: PaymentStatus.ALL,
    label: PaymentStatus.ALL,
  },
  {
    value: PaymentStatus.PAID,
    label: PaymentStatus.PAID,
  },
  {
    value: PaymentStatus.NOT_PAID,
    label: PaymentStatus.NOT_PAID,
  },
];
